import GlobalStyles from '@mui/material/GlobalStyles'
import { ThemeProvider } from '@mui/system'
import { globalStyles, theme } from 'config'
import 'config/awsExport'
import { AuthProvider, SidebarProvider } from 'context'
import { MaintenanceProvider } from 'context/maintenance'
import { SnackbarProvider } from 'notistack'
import ReactGA from 'react-ga4'
import { AppRoutes } from 'routes'

if (import.meta.env.VITE_GOOGLE_ANALYTICS) {
  ReactGA.initialize(import.meta.env.VITE_GOOGLE_ANALYTICS)
}

function App(): JSX.Element {
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <SidebarProvider>
          <MaintenanceProvider>
            <SnackbarProvider
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left'
              }}
            >
              <GlobalStyles styles={globalStyles} />
              <AppRoutes />
            </SnackbarProvider>
          </MaintenanceProvider>
        </SidebarProvider>
      </AuthProvider>
    </ThemeProvider>
  )
}

export default App
